import React from 'react';
import { Input } from '../../components/ui/input';
import { DatePickerFr } from '../../components/ui/DatePickerFr';
import { Label } from '../../components/ui/label';
import { Loader2, AlertTriangle, FileWarning, Upload, Plus, Trash2, FileCheck } from 'lucide-react';

export default function EligibilityPreventionSection(ctx) {
  const {
    AUTO_TYPES, accidentsCoutTotal, accidentsList, accidentsTravail, ancienneteAnnees, collapsed,
    config, effectif, experienceAnnees, loading, prefilledForMembreRef, pvReception,
    pvReceptionFiles, qualifications, referencesTravauxFiles, setAccidentsList, setAccidentsTravail, setAncienneteAnnees,
    setCollapsed, setConfig, setEffectif, setExperienceAnnees, setLoading, setPvReception,
    setPvReceptionFiles, setQualifications, setReferencesTravauxFiles, setSinistralitDate, setSinistralitFiles, setSinistresAnterieurs,
    setTerritoiresCA, setTypeMarche, setVentClientele, setVentContrat, setVentTravaux, sinistralitDate,
    sinistralitFiles, sinistresAnterieurs, territoireCATotal, territoiresCA, toggleQualif, typeMarche,
    uploadJustificatif, ventClientele, ventContrat, ventTravaux, membre, isSuperAdmin,
    nombreActivites} = ctx;

  return (
    <>
          {/* Prévention & Documentation (Couche 4 BATICO) */}
          <div className="bg-amber-50/40 border-2 border-amber-200 rounded-lg p-3 space-y-3" data-testid="prevention-documentation-block">
            <div className="flex items-center gap-2">
              <div className="w-7 h-7 rounded-md bg-amber-100 flex items-center justify-center">
                <FileWarning className="h-4 w-4 text-amber-700" />
              </div>
              <h4 className="text-sm font-bold text-amber-900">Prévention & Documentation</h4>
            </div>

            {/* Accidents du travail */}
            <div>
              <Label className="text-xs font-semibold text-slate-700 mb-2 block">
                Au cours des 5 dernières années, y a-t-il eu dans votre entreprise des accidents du travail ?
              </Label>
              <div className="flex items-center gap-3">
                <label className="flex items-center gap-1.5 cursor-pointer">
                  <input type="radio" name="accidents_travail" checked={accidentsTravail === true}
                    onChange={() => setAccidentsTravail(true)} data-testid="accidents-travail-oui" />
                  <span className="text-sm">Oui</span>
                </label>
                <label className="flex items-center gap-1.5 cursor-pointer">
                  <input type="radio" name="accidents_travail" checked={accidentsTravail === false}
                    onChange={() => { setAccidentsTravail(false); setAccidentsList([]); }} data-testid="accidents-travail-non" />
                  <span className="text-sm">Non</span>
                </label>
              </div>

              {accidentsTravail && (
                <div className="mt-3 bg-white rounded-md border border-amber-200 overflow-x-auto">
                  <table className="w-full text-xs">
                    <thead className="bg-amber-50 border-b border-amber-200">
                      <tr>
                        <th className="text-left px-2 py-1.5 font-semibold text-slate-700">Date</th>
                        <th className="text-left px-2 py-1.5 font-semibold text-slate-700">Causes</th>
                        <th className="text-left px-2 py-1.5 font-semibold text-slate-700">Circonstances et suites éventuelles</th>
                        <th className="text-right px-2 py-1.5 font-semibold text-slate-700 whitespace-nowrap">Coût estimé (€)</th>
                        <th className="w-8"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {accidentsList.length === 0 && (
                        <tr><td colSpan="5" className="text-center text-slate-400 italic py-2">Aucun accident déclaré — cliquez sur "Ajouter une ligne"</td></tr>
                      )}
                      {accidentsList.map((acc, idx) => (
                        <tr key={idx} className="border-b border-slate-100" data-testid={`accident-row-${idx}`}>
                          <td className="px-1.5 py-1">
                            <DatePickerFr value={acc.date || ''}
                              onChange={(v) => {
                                const list = [...accidentsList]; list[idx] = { ...list[idx], date: v };
                                setAccidentsList(list);
                              }}
                              className="h-7 text-xs" data-testid={`accident-date-${idx}`} />
                          </td>
                          <td className="px-1.5 py-1">
                            <Input type="text" value={acc.causes || ''} placeholder="Ex: chute échafaudage"
                              onChange={(e) => {
                                const list = [...accidentsList]; list[idx] = { ...list[idx], causes: e.target.value };
                                setAccidentsList(list);
                              }}
                              className="h-7 text-xs" data-testid={`accident-causes-${idx}`} />
                          </td>
                          <td className="px-1.5 py-1">
                            <Input type="text" value={acc.circonstances || ''} placeholder="Ex: arrêt 5j, dossier CPAM"
                              onChange={(e) => {
                                const list = [...accidentsList]; list[idx] = { ...list[idx], circonstances: e.target.value };
                                setAccidentsList(list);
                              }}
                              className="h-7 text-xs" data-testid={`accident-circ-${idx}`} />
                          </td>
                          <td className="px-1.5 py-1">
                            <Input type="number" min="0" step="100" value={acc.cout_estime ?? ''} placeholder="0"
                              onChange={(e) => {
                                const list = [...accidentsList]; list[idx] = { ...list[idx], cout_estime: e.target.value };
                                setAccidentsList(list);
                              }}
                              className="h-7 text-xs text-right font-mono w-24" data-testid={`accident-cout-${idx}`} />
                          </td>
                          <td className="px-1 py-1">
                            <button type="button"
                              onClick={() => setAccidentsList(accidentsList.filter((_, i) => i !== idx))}
                              className="text-rose-500 hover:bg-rose-50 rounded p-1"
                              data-testid={`accident-delete-${idx}`}
                            ><Trash2 className="h-3 w-3" /></button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                    {accidentsList.length > 0 && (() => {
                      const seuil = Number(config?.seuil_cout_accidents_eur || 50000);
                      const exceede = accidentsCoutTotal > seuil;
                      return (
                        <tfoot>
                          <tr className={exceede ? 'bg-rose-50' : 'bg-slate-50'}>
                            <td colSpan="3" className="px-2 py-1.5 text-right text-xs font-semibold">
                              {exceede && <AlertTriangle className="h-3.5 w-3.5 text-rose-600 inline mr-1" />}
                              Coût total déclaré
                            </td>
                            <td className={`px-2 py-1.5 text-right font-mono font-bold text-xs ${exceede ? 'text-rose-700' : 'text-slate-700'}`}>
                              {accidentsCoutTotal.toLocaleString('fr-FR')} €
                            </td>
                            <td></td>
                          </tr>
                          {exceede && (
                            <tr>
                              <td colSpan="5" className="px-2 py-1 text-[10px] text-rose-700 italic">
                                Seuil de {seuil.toLocaleString('fr-FR')} € dépassé → +{config?.score_bonus_cout_accidents_depasse ?? 10} pts au score (visibilité risque historique)
                              </td>
                            </tr>
                          )}
                        </tfoot>
                      );
                    })()}
                  </table>
                  <div className="p-1.5 border-t border-amber-200 text-right">
                    <button type="button"
                      onClick={() => setAccidentsList([...accidentsList, { date: '', causes: '', circonstances: '', cout_estime: '' }])}
                      className="text-[11px] inline-flex items-center gap-1 text-amber-700 hover:text-amber-900 font-medium"
                      data-testid="accident-add-row"
                    ><Plus className="h-3 w-3" /> Ajouter une ligne</button>
                  </div>
                </div>
              )}
            </div>

            {/* Sinistres antérieurs */}
            <div>
              <Label className="text-xs font-semibold text-slate-700 mb-2 block">
                Sinistres ou désordres antérieurs ?
              </Label>
              <div className="flex items-center gap-3 flex-wrap">
                <label className="flex items-center gap-1.5 cursor-pointer">
                  <input type="radio" name="sinistres_anterieurs" checked={sinistresAnterieurs === true}
                    onChange={() => setSinistresAnterieurs(true)} data-testid="sinistres-oui" />
                  <span className="text-sm">Oui</span>
                </label>
                <label className="flex items-center gap-1.5 cursor-pointer">
                  <input type="radio" name="sinistres_anterieurs" checked={sinistresAnterieurs === false}
                    onChange={() => {
                      setSinistresAnterieurs(false);
                      setSinistralitFiles([]);
                      setSinistralitDate('');
                    }} data-testid="sinistres-non" />
                  <span className="text-sm">Non</span>
                </label>
              </div>

              {sinistresAnterieurs && (
                <div className="mt-2.5 p-3 rounded-lg bg-rose-50/40 border border-rose-200 space-y-2">
                  <div className="flex flex-wrap items-end gap-3">
                    <div className="flex-1 min-w-[150px]">
                      <Label className="text-[10px] uppercase tracking-wide text-rose-700 font-semibold">
                        Date du relevé de sinistralité
                      </Label>
                      <DatePickerFr
                        value={sinistralitDate}
                        onChange={setSinistralitDate}
                        className="h-8 text-sm bg-white w-full"
                        id="sinistralite-date"
                      />
                    </div>
                    <label className="inline-flex items-center gap-1 cursor-pointer text-[11px] text-rose-700 hover:text-rose-900 font-medium border border-rose-300 rounded px-2 py-1 bg-white h-8">
                      <Upload className="h-3 w-3" />
                      <span>Téléverser le relevé (PDF/JPG/PNG)</span>
                      <input type="file" multiple accept="application/pdf,image/*"
                        onChange={(e) => {
                          Array.from(e.target.files || []).forEach((f) =>
                            uploadJustificatif(f, 'releve_sinistralite', setSinistralitFiles, sinistralitDate || null)
                          );
                          e.target.value = '';
                        }}
                        className="hidden" data-testid="sinistralite-files" />
                    </label>
                  </div>
                  {sinistralitFiles.length > 0 && (
                    <div className="flex flex-wrap gap-1">
                      {sinistralitFiles.map((f, idx) => (
                        <span key={idx} className={`inline-flex items-center gap-1 text-[10px] bg-white border rounded px-1.5 py-0.5 ${
                          f.status === 'error' ? 'border-rose-300 text-rose-700' :
                          f.status === 'uploading' ? 'border-amber-200 text-amber-700' :
                          'border-emerald-200 text-emerald-700'
                        }`}>
                          {f.status === 'uploading' ? <Loader2 className="h-3 w-3 animate-spin" /> :
                           f.status === 'error' ? <AlertTriangle className="h-3 w-3" /> :
                           <FileCheck className="h-3 w-3" />}
                          <span className="truncate max-w-[180px]">{f.name}</span>
                          {f.existing && <span className="text-[8px] text-emerald-600">déjà en GED</span>}
                          {f.status === 'error' && <span title={f.error}>⚠</span>}
                          <button type="button"
                            onClick={() => setSinistralitFiles(sinistralitFiles.filter((_, i) => i !== idx))}
                            className="text-rose-400 hover:text-rose-600 ml-1"
                          >×</button>
                        </span>
                      ))}
                    </div>
                  )}
                  <p className="text-[10px] text-rose-700/80">
                    📌 Le relevé sera automatiquement enregistré dans la fiche membre et la GED.
                  </p>
                </div>
              )}
            </div>

            {/* PV de réception */}
            <div>
              <Label className="text-xs font-semibold text-slate-700 mb-2 block">
                Présence de PV de réception ?
              </Label>
              <div className="flex items-center gap-3 flex-wrap">
                <label className="flex items-center gap-1.5 cursor-pointer">
                  <input type="radio" name="pv_reception" checked={pvReception === true}
                    onChange={() => setPvReception(true)} data-testid="pv-reception-oui" />
                  <span className="text-sm">Oui</span>
                </label>
                <label className="flex items-center gap-1.5 cursor-pointer">
                  <input type="radio" name="pv_reception" checked={pvReception === false}
                    onChange={() => { setPvReception(false); setPvReceptionFiles([]); }} data-testid="pv-reception-non" />
                  <span className="text-sm">Non</span>
                </label>
                {pvReception && (
                  <label className="inline-flex items-center gap-1 cursor-pointer text-[11px] text-amber-700 hover:text-amber-900 font-medium border border-amber-300 rounded px-2 py-1 bg-white">
                    <Upload className="h-3 w-3" />
                    <span>Téléverser PV (PDF/JPG/PNG)</span>
                    <input type="file" multiple accept="application/pdf,image/*"
                      onChange={(e) => {
                        Array.from(e.target.files || []).forEach((f) => uploadJustificatif(f, 'pv_reception', setPvReceptionFiles));
                        e.target.value = '';
                      }}
                      className="hidden" data-testid="pv-reception-files" />
                  </label>
                )}
              </div>
              {pvReceptionFiles.length > 0 && (
                <div className="mt-1.5 flex flex-wrap gap-1">
                  {pvReceptionFiles.map((f, idx) => (
                    <span key={idx} className={`inline-flex items-center gap-1 text-[10px] bg-white border rounded px-1.5 py-0.5 ${
                      f.status === 'error' ? 'border-rose-300 text-rose-700' :
                      f.status === 'uploading' ? 'border-amber-200 text-amber-700' :
                      'border-emerald-200 text-emerald-700'
                    }`}>
                      {f.status === 'uploading' ? <Loader2 className="h-3 w-3 animate-spin" /> :
                       f.status === 'error' ? <AlertTriangle className="h-3 w-3" /> :
                       <FileCheck className="h-3 w-3" />}
                      <span className="truncate max-w-[180px]">{f.name}</span>
                      {f.status === 'error' && <span title={f.error}>⚠</span>}
                      <button type="button"
                        onClick={() => setPvReceptionFiles(pvReceptionFiles.filter((_, i) => i !== idx))}
                        className="text-rose-400 hover:text-rose-600 ml-1"
                      >×</button>
                    </span>
                  ))}
                </div>
              )}
            </div>

            {/* Références travaux */}
            <div>
              <Label className="text-xs font-semibold text-slate-700 mb-2 block">
                Références travaux (factures, contrats de marché)
              </Label>
              <label className="inline-flex items-center gap-1 cursor-pointer text-[11px] text-amber-700 hover:text-amber-900 font-medium border border-amber-300 rounded px-2 py-1 bg-white">
                <Upload className="h-3 w-3" />
                <span>Téléverser références (PDF/JPG/PNG)</span>
                <input type="file" multiple accept="application/pdf,image/*"
                  onChange={(e) => {
                    Array.from(e.target.files || []).forEach((f) => uploadJustificatif(f, 'references_travaux', setReferencesTravauxFiles));
                    e.target.value = '';
                  }}
                  className="hidden" data-testid="references-travaux-files" />
              </label>
              {referencesTravauxFiles.length > 0 && (
                <div className="mt-1.5 flex flex-wrap gap-1">
                  {referencesTravauxFiles.map((f, idx) => (
                    <span key={idx} className={`inline-flex items-center gap-1 text-[10px] bg-white border rounded px-1.5 py-0.5 ${
                      f.status === 'error' ? 'border-rose-300 text-rose-700' :
                      f.status === 'uploading' ? 'border-amber-200 text-amber-700' :
                      'border-emerald-200 text-emerald-700'
                    }`}>
                      {f.status === 'uploading' ? <Loader2 className="h-3 w-3 animate-spin" /> :
                       f.status === 'error' ? <AlertTriangle className="h-3 w-3" /> :
                       <FileCheck className="h-3 w-3" />}
                      <span className="truncate max-w-[180px]">{f.name}</span>
                      {f.status === 'error' && <span title={f.error}>⚠</span>}
                      <button type="button"
                        onClick={() => setReferencesTravauxFiles(referencesTravauxFiles.filter((_, i) => i !== idx))}
                        className="text-rose-400 hover:text-rose-600 ml-1"
                      >×</button>
                    </span>
                  ))}
                </div>
              )}
            </div>
          </div>
    </>
  );
}
